import { schema } from 'normalizr';
import { Activity } from 'src/app/store/normalized/schemas/activity.schema';

export interface WeightActivity extends Activity {
  value: number;
  unit: string;
}

export const weightActivitySchema = new schema.Entity<WeightActivity>('weightActivities');
